/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Pnk_Reject_TitleInputs */

const vi_pl_pnk_reject_title = /** @type {(inputs: Pl_Pnk_Reject_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ chối PNK lô chè mua`)
};

/**

* @param {Pl_Pnk_Reject_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_pnk_reject_title = /** @type {((inputs?: Pl_Pnk_Reject_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Pnk_Reject_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_pnk_reject_title(inputs)
});